import { Configuration, InteractionType, PopupRequest } from '@azure/msal-browser';
import { env } from 'config/env';

const graphServerVersion = 'v1.0';
const graphServer = `https://graph.microsoft.com/${graphServerVersion}`;

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: env?.REACT_APP_ENTRAID_CLIENT_ID || '',
    authority: env?.REACT_APP_ENTRAID_AUTHORITY,
    redirectUri: '/',
    postLogoutRedirectUri: '/'
  },
  system: {
    allowNativeBroker: false // Disables WAM Broker
  }
};

export const interactionType = (env?.REACT_APP_ENTRAID_INTERACTION_TYPE ||
  InteractionType.Redirect) as InteractionType;

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: env?.REACT_APP_ENTRAID_LOGIN_SCOPES?.split(',') || []
};

export const GRAPH_USERS_API_LIMIT = 30;
export const EXTERNAL_INDICATOR_STRING = '#EXT#';

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: `${graphServer}/me`,
  graphUsersEndpoint: `${graphServer}/users`
};
